<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h550_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="城市"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="零售户名称"
                    prop="userName"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.userName"
                      disabled
                    >
                      <el-button
                        v-if="eventType==='add'"
                        slot="append"
                        icon="el-icon-search"
                        @click="showUserFun()"
                      />
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="电话"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.phone"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="店名"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.storeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="专卖证号"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.certificateNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="本香门店码"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.benxiangStoreNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="推荐码单日最大扫码数量"
                    prop="maxCount"
                  >
                    <el-input
                      v-model.number="dialogAddEditViewForm.maxCount"
                      :disabled="eventType==='view'"
                      :maxlength="8"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="消费者单日最大扫码数量"
                    prop="consumerDayCount"
                  >
                    <el-input
                      v-model.number="dialogAddEditViewForm.consumerDayCount"
                      :disabled="eventType==='view'"
                      :maxlength="8"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="推荐码每月最大扫码数量"
                    prop="consumerMonthCount"
                  >
                    <el-input
                      v-model.number="dialogAddEditViewForm.consumerMonthCount"
                      :disabled="eventType==='view'"
                      :maxlength="8"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="状态"
                    prop="status"
                  >
                    <el-radio-group
                      v-model="dialogAddEditViewForm.status"
                      :disabled="eventType==='view'"
                    >
                      <el-radio :label="1">
                        有效
                      </el-radio>
                      <el-radio :label="2">
                        无效
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="eventType==='view'"
                  :span="6"
                >
                  <el-form-item label="设置时间">
                    <el-input
                      v-model="dialogAddEditViewForm.lockTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 用户列表 -->
    <user-list-dialog
      :dialog-visible.sync="dialogUserVisible"
      dialog-title="用户信息"
      @selectedUserFun="selectedUserFun"
    />
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 用户
import userListDialog from './userListDialog'
import { initAppUserScanAbnormalLockApi, saveOrUpdateAppUserScanAbnormalLockApi } from '@/api/appUserScanAbnormalLock'
export default {
  components: { userListDialog },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {
      },
      dialogAddEditViewFormRules: {
        userName: [ { required: true, message: '请选择零售户', trigger: 'blur' }],
        status: [ { required: true, message: '请选择状态', trigger: 'change' }],
        maxCount: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { type: 'number', message: '必须为数字值', trigger: "blur" }
        ],
        consumerDayCount: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { type: 'number', message: '必须为数字值', trigger: "blur" }
        ],
        consumerMonthCount: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { type: 'number', message: '必须为数字值', trigger: "blur" }
        ],
        remark: [{ max: 512, message: '最多输入512个字符', trigger: 'blur' } ]
      },
      dialogUserVisible: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.dialogAddEditViewForm = {
          userId: null,
          provinceName: '',
          cityName: '',
          userName: '',
          phone: '',
          benxiangStoreNo: '',
          storeName: '',
          certificateNo: '',
          lockTimeStr: '',
          maxCount: 0,
          consumerDayCount: 0,
          consumerMonthCount: 0,
          status: 1,
          remark: ''
        }
        if(this.eventType === 'add'){
          this.loading = false
        } else {
          this.initPageDataFun()
        }
      }
    }
  },
  methods: {
    // 初始化页面数据
    initPageDataFun(){
      initAppUserScanAbnormalLockApi({ id: this.dataId }).then(res => {
        const { data } = res
        for(let key in this.dialogAddEditViewForm){
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    // 弹出用户选择
    showUserFun(){
      this.dialogUserVisible = true
    },
    // 选择用户
    selectedUserFun(val){
      this.dialogAddEditViewForm.userId = val.id
      this.dialogAddEditViewForm.userName = val.name
      this.dialogAddEditViewForm.phone = val.phone
      this.dialogAddEditViewForm.provinceName = val.provinceName
      this.dialogAddEditViewForm.cityName = val.cityName
      this.dialogAddEditViewForm.benxiangStoreNo = val.benxiangStoreNo
      this.dialogAddEditViewForm.storeName = val.storeName
      this.dialogAddEditViewForm.certificateNo = val.certificateNo
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '差异化设置信息','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.handlerSave()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    handlerSave () {
      this.dialogAddEditViewForm.isWeb = 1
      saveOrUpdateAppUserScanAbnormalLockApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss"  scoped>

</style>
